// Translate
<template>
  <CalendarSearchBarButton
    id="charterButtonAirport"
    ref="charterButtonAirport"
    :active="active"
    :loading="loading"
    @click="$emit('setActive')"
  >
    <template #icon>
      <fa :icon="icons.faPlaneDeparture" />
    </template>
    <template #label>
      <span data-i18n="charterSearchDeparture">
        {{ $t('charterSearchDeparture') }}
      </span>
    </template>
    <template #content>
      <span
        v-if="!selectedAirport?.airport_name"
        data-i18n="charterSearchSelect"
      >{{ $t('charterSearchSelect') }}</span>
      <span v-else>
        {{ selectedAirport.airport_name }}
      </span>
    </template>
    <template #append>
      <div
        v-if="selectAirportFirst"
        class="charter-search__btn-title text-error blink blink-title"
        data-i18n="charterSelectAirportFirst"
      >
        {{ $t('charterSelectAirportFirst') }}
      </div>
    </template>
  </CalendarSearchBarButton>
</template>

<script>
import { faPlaneDeparture } from '@fortawesome/pro-duotone-svg-icons'
import { mapState } from 'pinia'

export default defineNuxtComponent({
  props: {
    active: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    selectAirportFirst: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['setActive'],

  data () {
    return {
      icons: {
        faPlaneDeparture,
      },
    }
  },

  computed: {
    ...mapState(useDealfinderStore, {
      selectedAirport: 'selectedAirport',
    }),
  },
})
</script>
